import React from 'react';
import { DefaultFlexStrechedWrapper } from 'src/components/ui/odfjellPanel/OdfjellPanel.styles';
import { ReportOptionDescriptionText, ReportOptionIconWrapper, ReportOptionWrapper } from '../PageHeaderStowage.style';
import { OptionOpacityWrapper } from './reportPanel.style';

interface ManualCargoesOnlySelectorProps {
    manualCargoesOnly: boolean;
    setManualCargoesOnly: (manualCargoesOnly: boolean) => void;
    disabled?: boolean;
}

const ManualCargoesOnlySelector: React.FC<ManualCargoesOnlySelectorProps> = ({ manualCargoesOnly, setManualCargoesOnly, disabled }) => {
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setManualCargoesOnly(event.target.checked);
    };

    return (
        <ReportOptionWrapper onClick={() => !disabled && setManualCargoesOnly(!manualCargoesOnly)} disabled={disabled}>
            <OptionOpacityWrapper disabled={disabled}>
                <DefaultFlexStrechedWrapper noMargin>
                    <ReportOptionIconWrapper>
                        <input
                            type="checkbox"
                            checked={manualCargoesOnly}
                            onChange={handleChange}
                            onClick={(e) => e.stopPropagation()}
                            aria-label="Manual cargoes only"
                            disabled={disabled}
                            style={{ cursor: disabled ? 'not-allowed' : 'pointer' }}
                        />
                    </ReportOptionIconWrapper>
                    <ReportOptionDescriptionText>Manual cargoes only</ReportOptionDescriptionText>
                </DefaultFlexStrechedWrapper>
            </OptionOpacityWrapper>
        </ReportOptionWrapper>
    );
};

export default ManualCargoesOnlySelector;
